// =============================================================================
// 📝 INOCHI Showcase Page Content
// =============================================================================
// Edit this file to update the INOCHI showcase page at /showcase/inochi.
// All text, images, videos and metrics live here.
// =============================================================================

export const INOCHI = {
  // ---------- 1. BUSINESS OVERVIEW ----------
  overview: {
    name: "INOCHI",
    tagline: "Power of Life · Japanese Anti-Aging Beauty",
    category: "Health & Beauty · Premium Anti-Aging Skincare",
    origin: "Japan · In Partnership with Picaso Natural Cosmetic Japan (Since 1935)",
    intro: "INOCHI Beauty is a premium Japanese anti-aging skincare brand built on 90+ years of cosmetic heritage. Powered by Nano-Encapsulation Technology, INOCHI delivers powerful active ingredients deep into the skin for instant lifting, glowing and visible results.",
    brandStory: "INOCHI is the result of a partnership between MIRESCO Group Holding Berhad and Picaso Natural Cosmetic Japan — a Japanese cosmetic house operating since 1935. Combining nearly a century of Japanese cosmetic mastery with breakthrough Nano-Encapsulation Technology, INOCHI brings aesthetic-grade results to everyday skincare. Each formula is designed in Japan with proven actives — Pullulan, Hyaluronic Acid and Soybean Extract — for instant lifting and glowing effects.",
    marketOpportunity: "Asia's anti-aging skincare market is the fastest growing in the world. Driven by rising demand for aesthetic-grade results without clinic visits, INOCHI is positioned at the centre of this premium segment — and is actively recruiting Malaysian affiliates and agents to capture it.",
    highlights: [
      "Partnership with Picaso Natural Cosmetic Japan — since 1935",
      "Nano-Encapsulation Technology for deep skin penetration",
      "Active ingredients: Pullulan · Hyaluronic Acid · Soybean Extract",
      "Visible results: Instant Lifting + Glowing Effect",
      "Aesthetic-grade quality · home-use convenience",
    ],
    heroImage: "/brand/inochi.png",
  },

  // ---------- 2. OPPORTUNITY TYPES AVAILABLE ----------
  opportunities: [
    {
      key: "affiliate",
      icon: "Sparkles",
      title: "INOCHI Affiliate",
      capital: "RM 0",
      summary: "Earn commission on every sale — no stock, no upfront cost.",
      bullets: [
        "Promote with your unique link or QR code",
        "Up to 25% commission per sale",
        "Monthly payout",
        "Marketing kit & training provided",
      ],
      ctaLabel: "Apply as Affiliate",
    },
    {
      key: "agent",
      icon: "Briefcase",
      title: "INOCHI Agent",
      capital: "From RM 1,500",
      summary: "Hold inventory, sell direct & build a customer base in your area.",
      bullets: [
        "Up to 40% margin on inventory",
        "Exclusive territory rights available",
        "Priority restocking",
        "Dedicated agent support",
      ],
      ctaLabel: "Apply as Agent",
      featured: true,
    },
  ],

  // ---------- 3. PRODUCT GALLERY ----------
  // The INOCHI product line — Cleanser, Powerful Glowing Serum and other nano-encapsulated products.
  productGallery: [
    { src: "/brand/inochi.png", alt: "INOCHI Beauty — Science Behind the Brand" },
    { src: "https://images.unsplash.com/photo-1570554886111-e80fcca6a029?w=900&q=85&auto=format&fit=crop", alt: "INOCHI skincare set" },
    { src: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=900&q=85&auto=format&fit=crop", alt: "INOCHI moisturizer" },
    { src: "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=900&q=85&auto=format&fit=crop", alt: "Japanese skincare ritual" },
    { src: "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?w=900&q=85&auto=format&fit=crop", alt: "Premium beauty packaging" },
    { src: "https://images.unsplash.com/photo-1631730486572-226d1f595b68?w=900&q=85&auto=format&fit=crop", alt: "Japanese beauty essentials" },
  ],

  // ---------- 4. PROMOTIONAL VIDEOS ----------
  // Add YouTube/Vimeo URLs. For coming-soon, leave url empty.
  videos: [
    { key: "intro",  title: "Product Introduction",      thumb: "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=600&q=80&auto=format&fit=crop", url: "" },
    { key: "demo",   title: "Application Demonstration", thumb: "https://images.unsplash.com/photo-1570554886111-e80fcca6a029?w=600&q=80&auto=format&fit=crop", url: "" },
    { key: "benefit",title: "Anti-Aging Benefits",       thumb: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=600&q=80&auto=format&fit=crop", url: "" },
    { key: "founder",title: "Founder's Message",         thumb: "https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?w=600&q=80&auto=format&fit=crop", url: "" },
  ],

  // ---------- 5. TESTIMONIALS ----------
  testimonials: [
    {
      key: "t1",
      type: "customer",
      author: "Aisyah Rahman",
      role: "INOCHI Customer · KL",
      photo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80&auto=format&fit=crop&crop=faces",
      quote: "After 6 weeks, my fine lines were visibly softer. INOCHI is the first Japanese serum I've kept repurchasing.",
    },
    {
      key: "t2",
      type: "affiliate",
      author: "Marina L.",
      role: "INOCHI Affiliate · Penang",
      photo: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&q=80&auto=format&fit=crop&crop=faces",
      quote: "I earned RM 2,400 in my first month with zero capital. The marketing kit made everything easy.",
    },
    {
      key: "t3",
      type: "agent",
      author: "Rashid bin Omar",
      role: "INOCHI Agent · Johor",
      photo: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80&auto=format&fit=crop&crop=faces",
      quote: "Restocking is fast and my Johor territory is growing month over month. Best Japanese brand to carry.",
    },
  ],

  // ---------- 6. TRAINING & SUPPORT ----------
  training: [
    { icon: "BookOpen", title: "Product Knowledge",      desc: "Full guide to the INOCHI line — ingredients, results, safe use." },
    { icon: "MessageSquare", title: "Sales Scripts",     desc: "Proven scripts for affiliates and agents to convert customers." },
    { icon: "TrendingUp",title: "Marketing Playbook",    desc: "Social media templates, ad creatives and influencer playbooks." },
    { icon: "HelpCircle",title: "Live Onboarding Calls", desc: "Weekly Zoom sessions with the INOCHI team and successful agents." },
  ],

  // ---------- 7. INCOME OPPORTUNITY ----------
  income: {
    headline: "Earn from day one. Scale at your pace.",
    body: "INOCHI rewards both performance and loyalty. Choose the path that fits you — start as an affiliate with zero capital, or invest as an agent for higher margins and exclusive territory rights.",
    tiers: [
      { tier: "Affiliate Starter", commission: "15%",   conditions: "Per sale · Zero capital · Pay on conversion" },
      { tier: "Affiliate Pro",     commission: "20-25%", conditions: "After RM 3,000 monthly sales · Bonus accelerators" },
      { tier: "Agent",             commission: "30-40%", conditions: "Inventory holding · Higher margin · Territory rights" },
      { tier: "Agent + Territory", commission: "40% + monthly bonus", conditions: "Exclusive area · Performance bonus · Restocking priority" },
    ],
  },

  // ---------- 8. SUCCESS METRICS ----------
  // Update these numbers as your network grows.
  metrics: [
    { key: "customers",  label: "Happy Customers",   value: "12,400+" },
    { key: "affiliates", label: "Active Affiliates", value: "320+"    },
    { key: "agents",     label: "Active Agents",     value: "45+"     },
    { key: "states",     label: "States Covered",    value: "13"      },
  ],

  // ---------- 9. FAQ ----------
  faq: [
    {
      q: "How much capital is required to start?",
      a: "RM 0 as an affiliate — you earn commission per sale with no stock. As an agent, packages start from RM 1,500 with inventory included.",
    },
    {
      q: "How much commission can I earn?",
      a: "Affiliates earn 15-25% per sale. Agents earn 30-40% margin on inventory, plus monthly performance bonuses.",
    },
    {
      q: "Do I need to keep stock?",
      a: "No — only as an agent if you choose. Affiliates use a unique link/QR and never handle inventory.",
    },
    {
      q: "How do I receive payment?",
      a: "Monthly payouts via Malaysian bank transfer. Statements are visible inside your MIRESCO dashboard.",
    },
    {
      q: "What support is provided?",
      a: "Full marketing kit, product knowledge training, sales scripts and weekly onboarding calls. Plus a dedicated agent success manager.",
    },
    {
      q: "Is INOCHI authentic Japanese skincare?",
      a: "Yes — INOCHI is formulated and manufactured in Japan, then imported under proper KKM compliance.",
    },
  ],

  // ---------- 10. APPLICATION ----------
  // Where the Apply buttons take the user. Login flow handles routing.
  applyRoute: "/opportunities?vendor=inochi",
};
